import { LoadingButtonProps } from "@mui/lab";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  ButtonProps,
  IconButton,
  IconButtonProps,
  styled,
} from "@mui/material";
import { Link } from "react-router-dom";
import { forwardRef, useMemo } from "react";
import { CustomLinkButtonProps, CustomLinkProps } from "utils/interface";

export function CustomLoadingButton(props: LoadingButtonProps & ButtonProps) {
  const { className = "", variant = "contained", children } = props;
  return (
    <LoadingButton className={className} variant={variant} {...props}>
      {children}
    </LoadingButton>
  );
}
export function CustomLinkButton(props: CustomLinkButtonProps) {
  const { className = "", to = "#", children } = props;

  // Create a forwardRef component for the Link to fix ref warning
  // Memoize it to prevent recreating on every render
  const LinkComponent = useMemo(() => {
    return forwardRef<HTMLAnchorElement, any>((linkProps, ref) => {
      return (
        <Link ref={ref} to={to} {...linkProps}>
          {linkProps.children}
        </Link>
      );
    });
  }, [to]);

  if (!LinkComponent.displayName) {
    LinkComponent.displayName = "LinkComponent";
  }

  return (
    <LoadingButton
      {...props}
      className={className}
      LinkComponent={LinkComponent}
      sx={{
        textTransform: "none",
      }}
    >
      {children}
    </LoadingButton>
  );
}

export function CustomIconButton(props: IconButtonProps) {
  const { className = "", children } = props;
  return (
    <IconButton {...props} className={className}>
      {children}
    </IconButton>
  );
}

export function CustomLink(props: CustomLinkProps) {
  const { to } = props;
  return (
    <CustomLinkWrapper {...props} to={to}>
      {props.children}
    </CustomLinkWrapper>
  );
}

const CustomLinkWrapper = styled(Link)(() => ({
  color: "#00A3FF",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
}));
